/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { AVAILABLE_PATHS } from "../PrivateRouter";
import { setFerrari } from "../store/slice/privateSlice";
import { setConfiguredStunServer, setIsInMaintenance, setIsRoomAlive } from "../store/slice/roomSlice";
import store from "../store/store";

export const getConfiguredStunServer = async () => {
    await fetch(`https://${process.env.REACT_APP_BACKEND_HOST || window.location.hostname
        }:${process.env.REACT_APP_BACKEND_PORT || window.location.port}/configuredStunServer`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer"
    }).then((res) => {
        return res.json();
    }).then((data) => {
        store.dispatch(setConfiguredStunServer(data))
    }).catch((e) => {
        console.log(e);
    })
}

export const getIsRoomAlive = async (roomId) => {
    await fetch(`https://${process.env.REACT_APP_BACKEND_HOST || window.location.hostname
        }:${process.env.REACT_APP_BACKEND_PORT || window.location.port}/isRoomAlive`, {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify({ roomId }),
    }).then((res) => {
        return res.json();
    }).then((data) => {
        store.dispatch(setIsRoomAlive(data ||
            AVAILABLE_PATHS
                .flatMap((availablePath) => [availablePath.path, availablePath.path.concat('/')])
                .includes(window.location.pathname)))
    }).catch((e) => {
        console.log(e);
    })
}

export const getIsInMaintenance = async () => {
    await fetch(`https://${process.env.REACT_APP_BACKEND_HOST || window.location.hostname
        }:${process.env.REACT_APP_BACKEND_PORT || window.location.port}/isInMaintenance`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer"
    }).then((res) => {
        return res.json();
    }).then((data) => {
        store.dispatch(setIsInMaintenance(data))
    }).catch((e) => {
        console.log(e);
    })
}

export const getFerrari = async () => {
    await fetch(`https://${process.env.REACT_APP_BACKEND_HOST || window.location.hostname
        }:${process.env.REACT_APP_BACKEND_PORT || window.location.port}/ferrari`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer"
    }).then((res) => {
        return res.json();
    }).then((data) => {
        store.dispatch(setFerrari(data))
    }).catch((e) => {
        console.log(e);
    })
}